// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/light_baker_arealight.fragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'light_baker_arealightPixelShader';
const shader = `#ifdef GL_ES
precision highp float;
#endif
varying vec2 vUV;
varying vec2 vUV2;
varying vec3 vPos;
varying vec3 vNormalW;
varying vec4 vWorldPos;
uniform sampler2D previousTexture;
uniform float num_samples_total;
uniform float first_sample_index;
uniform vec3 light_centers[NUM_AREA_LIGHTS];
uniform vec3 light_colors[NUM_AREA_LIGHTS];
uniform vec2 light_sizes[NUM_AREA_LIGHTS];
uniform float light_intensities[NUM_AREA_LIGHTS];
uniform float light_roty[NUM_AREA_LIGHTS];
uniform float light_rotz[NUM_AREA_LIGHTS];
float uniformNoise(vec2 n){
return fract(sin(dot(n, vec2(12.9898, 78.233))) * 43758.5453);
}
vec4 pack(float depth)
{
const vec4 bit_shift = vec4(255.0 * 255.0 * 255.0, 255.0 * 255.0, 255.0, 1.0);
const vec4 bit_mask = vec4(0.0, 1.0 / 255.0, 1.0 / 255.0, 1.0 / 255.0);
vec4 res = fract(depth * bit_shift);
res -= res.xxyz * bit_mask;
return res;
}
float unpack(vec4 color)
{
const vec4 bit_shift = vec4(1.0 / (255.0 * 255.0 * 255.0), 1.0 / (255.0 * 255.0), 1.0 / 255.0, 1.0);
return dot(color, bit_shift);
}
float intersectPlane(vec3 p, vec3 dir, vec3 n, float d) {
return  -(dot(p, n) + d) / dot(dir, n);
}
void best(inout float t, float nt) {
if (nt >= 0.0 && nt < t) {
t = nt;
}
}
const float roughness = 1.0;
const vec3  dcolor = vec3(1.0, 1.0, 0.87);
const vec3  scolor = vec3(1);
const float LUT_SIZE  = 64.0;
const float LUT_SCALE = (LUT_SIZE - 1.0)/LUT_SIZE;
const float LUT_BIAS  = 0.5/LUT_SIZE;
const float pi = 3.14159265;
struct Ray
{
vec3 origin;
vec3 dir;
};
struct Rect
{
vec3  center;
vec3  dirx;
vec3  diry;
float halfx;
float halfy;
vec4  plane;
};
vec3 mul(mat3 m, vec3 v)
{
return m * v;
}
mat3 mul(mat3 m1, mat3 m2)
{
return m1 * m2;
}
vec3 rotation_y(vec3 v, float a)
{
vec3 r;
r.x =  v.x*cos(a) + v.z*sin(a);
r.y =  v.y;
r.z = -v.x*sin(a) + v.z*cos(a);
return r;
}
vec3 rotation_z(vec3 v, float a)
{
vec3 r;
r.x =  v.x*cos(a) - v.y*sin(a);
r.y =  v.x*sin(a) + v.y*cos(a);
r.z =  v.z;
return r;
}
vec3 rotation_yz(vec3 v, float ay, float az)
{
return rotation_z(rotation_y(v, ay), az);
}
#if __VERSION__  == 100
mat3 transpose(mat3 v) {
mat3 tmp;
tmp[0] = vec3(v[0].x, v[1].x, v[2].x);
tmp[1] = vec3(v[0].y, v[1].y, v[2].y);
tmp[2] = vec3(v[0].z, v[1].z, v[2].z);
return tmp;
}
#endif
vec3 perpendicular(const vec3 v) {
if (abs(v.x) <= abs(v.y)) {
return vec3(0.0, -v.z, v.y);
} else {
return vec3(-v.z, 0.0, v.x);
}
}
float IntegrateEdge(vec3 v1, vec3 v2)
{
float cosTheta = dot(v1, v2);
float theta = acos(cosTheta);
float res = cross(v1, v2).z * ((theta > 0.001) ? theta/sin(theta) : 1.0);
return res;
}
void ClipQuadToHorizon(inout vec3 L[5], out int n)
{
int config = 0;
if (L[0].z > 0.0) config += 1;
if (L[1].z > 0.0) config += 2;
if (L[2].z > 0.0) config += 4;
if (L[3].z > 0.0) config += 8;
n = 0;
if (config == 0)
{
}
else if (config == 1)
{
n = 3;
L[1] = -L[1].z * L[0] + L[0].z * L[1];
L[2] = -L[3].z * L[0] + L[0].z * L[3];
}
else if (config == 2)
{
n = 3;
L[0] = -L[0].z * L[1] + L[1].z * L[0];
L[2] = -L[2].z * L[1] + L[1].z * L[2];
}
else if (config == 3)
{
n = 4;
L[2] = -L[2].z * L[1] + L[1].z * L[2];
L[3] = -L[3].z * L[0] + L[0].z * L[3];
}
else if (config == 4)
{
n = 3;
L[0] = -L[3].z * L[2] + L[2].z * L[3];
L[1] = -L[1].z * L[2] + L[2].z * L[1];
}
else if (config == 5)
{
n = 0;
}
else if (config == 6)
{
n = 4;
L[0] = -L[0].z * L[1] + L[1].z * L[0];
L[3] = -L[3].z * L[2] + L[2].z * L[3];
}
else if (config == 7)
{
n = 5;
L[4] = -L[3].z * L[0] + L[0].z * L[3];
L[3] = -L[3].z * L[2] + L[2].z * L[3];
}
else if (config == 8)
{
n = 3;
L[0] = -L[0].z * L[3] + L[3].z * L[0];
L[1] = -L[2].z * L[3] + L[3].z * L[2];
L[2] =  L[3];
}
else if (config == 9)
{
n = 4;
L[1] = -L[1].z * L[0] + L[0].z * L[1];
L[2] = -L[2].z * L[3] + L[3].z * L[2];
}
else if (config == 10)
{
n = 0;
}
else if (config == 11)
{
n = 5;
L[4] = L[3];
L[3] = -L[2].z * L[3] + L[3].z * L[2];
L[2] = -L[2].z * L[1] + L[1].z * L[2];
}
else if (config == 12)
{
n = 4;
L[1] = -L[1].z * L[2] + L[2].z * L[1];
L[0] = -L[0].z * L[3] + L[3].z * L[0];
}
else if (config == 13)
{
n = 5;
L[4] = L[3];
L[3] = L[2];
L[2] = -L[1].z * L[2] + L[2].z * L[1];
L[1] = -L[1].z * L[0] + L[0].z * L[1];
}
else if (config == 14)
{
n = 5;
L[4] = -L[0].z * L[3] + L[3].z * L[0];
L[0] = -L[0].z * L[1] + L[1].z * L[0];
}
else if (config == 15)
{
n = 4;
}
if (n == 3)
L[3] = L[0];
if (n == 4)
L[4] = L[0];
}
vec3 LTC_Evaluate(
vec3 N, vec3 P, mat3 Minv, vec3 points[4], bool twoSided)
{
vec3 T1, T2;
T1 = normalize(perpendicular(N));
T2 = cross(N, T1);
Minv = mul(Minv, transpose(mat3(T1, T2, N)));
vec3 L[5];
L[0] = mul(Minv, points[0] - P);
L[1] = mul(Minv, points[1] - P);
L[2] = mul(Minv, points[2] - P);
L[3] = mul(Minv, points[3] - P);
int n;
ClipQuadToHorizon(L, n);
if (n == 0)
return vec3(0, 0, 0);
L[0] = normalize(L[0]);
L[1] = normalize(L[1]);
L[2] = normalize(L[2]);
L[3] = normalize(L[3]);
L[4] = normalize(L[4]);
float sum = 0.0;
sum += IntegrateEdge(L[0], L[1]);
sum += IntegrateEdge(L[1], L[2]);
sum += IntegrateEdge(L[2], L[3]);
if (n >= 4)
sum += IntegrateEdge(L[3], L[4]);
if (n == 5)
sum += IntegrateEdge(L[4], L[0]);
sum = max(0.0, sum);
vec3 Lo_i = vec3(sum, sum, sum);
return Lo_i;
}
void InitRect(vec3 center, vec2 size, float roty, float rotz, out Rect rect)
{
rect.dirx = rotation_yz(vec3(1, 0, 0), roty, rotz);
rect.diry = rotation_yz(vec3(0, 1, 0), roty, rotz);
rect.center = center;
rect.halfx  = 0.5*size.x;
rect.halfy  = 0.5*size.y;
vec3 rectNormal = cross(rect.dirx, rect.diry);
rect.plane = vec4(rectNormal, -dot(rectNormal, rect.center));
}
void InitRectPoints(Rect rect, out vec3 points[4])
{
vec3 ex = rect.halfx*rect.dirx;
vec3 ey = rect.halfy*rect.diry;
points[0] = rect.center - ex - ey;
points[1] = rect.center + ex - ey;
points[2] = rect.center + ex + ey;
points[3] = rect.center - ex + ey;
}
float saturate(float v)
{
return clamp(v, 0.0, 1.0);
}
vec3 PowVec3(vec3 v, float p)
{
return vec3(pow(v.x, p), pow(v.y, p), pow(v.z, p));
}
const float gamma = 2.2;
vec3 ToLinear(vec3 v) { return PowVec3(v,     gamma); }
vec3 ToSRGB(vec3 v)   { return PowVec3(v, 1.0/gamma); }
float triangleNoise(const vec2 n) {
vec2 p = fract(n * vec2(5.3987, 5.4421));
p += dot(p.yx, p.xy + vec2(21.5351, 14.3137));
float xy = p.x * p.y;
float noise = (fract(xy * 95.4307) + fract(xy * 75.04961) - 1.0);
return noise;
}
#define RGB_TRIANGLE_NOISE 1
vec4 Dither_TriangleNoise(vec4 rgba) {
#if RGB_TRIANGLE_NOISE == 1
vec3 noise = vec3(
triangleNoise(vUV         ) / (255.0),
triangleNoise(vUV + 0.1337) / (255.0),
triangleNoise(vUV + 0.3141) / (255.0)
);
#else
vec3 noise = vec3(triangleNoise(vUV) / (255.0));
#endif
return vec4(rgba.rgb + noise, rgba.a);
}
float srgb2lin(float v) {
if (v <= 0.04045) {
return v / 12.92;
}
return pow((v + 0.055) / 1.055, 2.4);
}
vec3 srgb2lin(vec3 col) {
return vec3(
srgb2lin(col.r),
srgb2lin(col.g),
srgb2lin(col.b)
);
}
void main(void) {
ivec2 pixel_index = ivec2(mod(gl_FragCoord.xy, 32.0));
int seed = pixel_index.x + pixel_index.y * 32;
float jit = float(seed) / (32.0*32.0) * 2.0 * 3.1415;
float index = first_sample_index;
vec3 normal = normalize(vNormalW.xyz);
vec3 pos = vWorldPos.xyz + normal * 0.001;
float total = 0.0;
float num_samples_per_frame = index - first_sample_index;
vec3 col = vec3(0);
for (int i = 0; i < NUM_AREA_LIGHTS; i++) {
Rect rect;
InitRect(light_centers[i], light_sizes[i], light_roty[i], light_rotz[i], rect);
vec3 points[4];
InitRectPoints(rect, points);
vec3 lcol = srgb2lin(light_colors[i]) * light_intensities[i];
vec3 N = normal;
vec3 diff = LTC_Evaluate(N, pos, mat3(1), points, false);
col += lcol*(diff) / (2.0*pi);
}
col += vec3(0.05, 0.05, 0.07);
gl_FragColor = Dither_TriangleNoise(vec4(pow(col.rgb, vec3(1.0/4.0)),1.0));
}
`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const light_baker_arealightPixelShader = { name, shader };
//# sourceMappingURL=light_baker_arealight.fragment.js.map